var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "maincategories-list" },
    _vm._l(_vm.categories, function(category) {
      return _c("li", { class: ["maincategories-list__item", category.slug] }, [
        _c(
          "span",
          {
            class: ["maincategories-list__item-inner", category.is_active],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.active(category.id)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(category.name) + "\n    ")]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }